/**
 * Language mapping configuration for the pagination component
 */
export const LANGUAGE_MAP: Record<string, string> = {
  pt: 'pt_BR',
  'pt-br': 'pt_BR',
  pt_BR: 'pt_BR',
  en: 'en_US',
  'en-us': 'en_US',
  en_US: 'en_US',
  es: 'es_MX',
  'es-mx': 'es_MX',
  es_MX: 'es_MX',
} as const;

/**
 * Default values for the component
 */
export const DEFAULT_LANGUAGE = 'en_US';

/**
 * Maps language codes to the format required by BdsPagination component
 * @param lang - The input language code
 * @returns The formatted language code
 */
export const getLanguageCode = (lang: string): string => {
  return LANGUAGE_MAP[lang?.toLowerCase()] || DEFAULT_LANGUAGE;
};
